/**
 * Meta Pixel — thin browser wrapper.
 *
 * - No-ops when REACT_APP_META_PIXEL_ID is unset.
 * - Idempotent init (safe under React Strict Mode double-mount).
 * - All ecommerce events use AUD currency (we charge in AUD).
 * - SKU format MUST match the backend feed: `{product_id}-{color|default}-{size|onesize}`
 */
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
let initialized = false;

const injectBase = () => {
  if (typeof window === "undefined" || window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
  (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
};

export const initMetaPixel = () => {
  if (!PIXEL_ID || initialized) return;
  injectBase();
  if (window.fbq) {
    window.fbq("init", PIXEL_ID);
    initialized = true;
  }
};

const track = (event, params) => {
  if (!PIXEL_ID || !window.fbq) return;
  if (params) window.fbq("track", event, params);
  else window.fbq("track", event);
};

export const makeVariantSku = (productId, color, size) => {
  const c = (color || "").trim() || "default";
  const s = (size || "").trim() || "onesize";
  return `${productId}-${c}-${s}`;
};

export const trackPageView = () => track("PageView");

export const trackViewContent = ({ content_ids, content_name, value, currency = "AUD" }) =>
  track("ViewContent", { content_ids, content_name, value, currency, content_type: "product" });

export const trackAddToCart = ({ content_ids, content_name, value, currency = "AUD" }) =>
  track("AddToCart", { content_ids, content_name, value, currency, content_type: "product" });

export const trackInitiateCheckout = ({ content_ids, num_items, value, currency = "AUD" }) =>
  track("InitiateCheckout", { content_ids, num_items, value, currency });

export const trackPurchase = ({ content_ids, num_items, value, currency = "AUD" }) =>
  track("Purchase", { content_ids, num_items, value, currency });

export const trackLead = (params) => track("Lead", params);
